import { create } from "zustand";
import jwtDecode from "jwt-decode";

export const GeneralStore = create()((set) => ({
  user: localStorage.getItem("authToken")
    ? jwtDecode(localStorage.getItem("authToken"))
    : null,
  setUser: () => {
    set({ user: jwtDecode(localStorage.getItem("authToken")) });
  },
  login: (accessToken, refreshToken) => {
    localStorage.setItem("authToken", accessToken);
    localStorage.setItem("refreshToken", refreshToken);
    set({ user: jwtDecode(accessToken) });
  },
  logout: () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("refreshToken");
    set({ user: null });
  },
  sidebarCollapsed:
    localStorage.getItem("sidebarCollapsed") == "true" ? true : false,
  setSidebarCollapsed: (collapsed) => {
    localStorage.setItem("sidebarCollapsed", collapsed.toString());
    set({ sidebarCollapsed: collapsed });
  },
  pageTitle: "",
  setPageTitle: (title) => {
    set({ pageTitle: title });
  },
  mobileSidebarOpen: false,
  setMobileSidebarOpen: (open) => {
    set({ mobileSidebarOpen: open });
  },
  contentPadding: true,
  setContentPadding: (padding) => {
    set({ contentPadding: padding });
  },
}));
